// GENERATED FILE — do not edit by hand.
//
// Mirror of the gateway's named authorization policies
// (src/Tyndo.Gateway/Startup/GatewayAuthorizationPolicies.cs), regenerated by
// `node scripts/generate-ui-server-policies.mjs` and drift-checked by the same
// script with `--check` (wired into the UI lint task).
//
// WHAT THIS IS FOR
// ────────────────
// `usePermission(resource, action)` asks whether the principal holds a
// `Resource:Action` string from `GET /api/v1/auth/me`. Nothing in the
// repository ever writes such a row except a single `("*","*")` dev-tenant
// wildcard, so in any real tenant every such check denies unconditionally and
// no grant can change it. The server gates endpoints on these ROLE POLICIES
// instead. A UI affordance should mirror the policy that guards the endpoint it
// calls — see `useServerPolicy`.
//
// An empty role list means the policy is `RequireAuthenticatedUser()` only:
// any signed-in principal satisfies it.

export const SERVER_POLICY_ROLES = {
  "Admin.Full": ['Admin'],
  "Admin.Operations": ['Admin', 'Operator', 'Manager'],
  "Admin.Read": ['Admin', 'Auditor', 'Operator', 'Manager'],
  "Agent.Approver": ['Admin', 'AgentApprover', 'Manager', 'ProductionSupervisor'],
  "Alarms.Engineer": ['Admin', 'AlarmsEngineer', 'ControlsEngineer', 'Manager'],
  "Alarms.Operator": ['Admin', 'AlarmsOperator', 'Operator'],
  "Authenticated.User": [],
  "Batch.Manager": ['Admin', 'BatchManager', 'Manager'],
  "Batch.Operator": ['Admin', 'BatchOperator', 'BatchManager', 'Operator'],
  "Batch.QualityReviewer": ['Admin', 'BatchQualityReviewer', 'QualityManager', 'Manager'],
  "CRM.Agent": ['Admin', 'CRMAgent', 'CRMManager', 'SalesRep', 'Manager'],
  "CRM.Manager": ['Admin', 'CRMManager', 'Manager'],
  "Collaboration.Participant": [],
  "Compliance.Approver": ['Admin', 'ComplianceApprover', 'QualityManager', 'Manager'],
  "Compliance.Auditor": ['Admin', 'ComplianceAuditor', 'Auditor'],
  "Compliance.Author": ['Admin', 'ComplianceAuthor', 'ComplianceAuditor', 'QualityAuthor', 'Manager'],
  "Compliance.RecordsManager": ['Admin', 'ComplianceRecordsManager', 'Manager'],
  "Controls.Engineer": ['Admin', 'ControlsEngineer', 'Manager'],
  "Controls.SafetyApprover": ['Admin', 'ControlsSafetyApprover'],
  "Copilot.Admin": ['Admin', 'CopilotAdmin', 'Manager'],
  "Copilot.Approver": ['Admin', 'CopilotApprover', 'Manager', 'ProductionSupervisor'],
  "Copilot.Invoker": ['Admin', 'CopilotInvoker', 'Operator', 'Manager'],
  "Costing.Analyst": ['Admin', 'CostingAnalyst', 'FinanceAccountant', 'Manager'],
  "Costing.Approver": ['Admin', 'CostingManager', 'FinanceController', 'Manager', 'CFO'],
  "Costing.Approver.Cfo": ['Admin', 'CFO'],
  "Costing.Approver.Director": ['Admin', 'FinanceController', 'CFO'],
  "Credit.Manager": ['Admin', 'CreditManager', 'FinanceController', 'Manager'],
  "Designer.Approver": ['Admin', 'DesignerApprover', 'Manager'],
  "Designer.Editor": ['Admin', 'DesignerEditor', 'Manager'],
  "Designer.Publisher": ['Admin', 'DesignerPublisher', 'Manager'],
  "Designer.Viewer": ['Admin', 'DesignerViewer', 'DesignerEditor', 'DesignerPublisher', 'DesignerApprover', 'Manager'],
  "DigitalTwin.Operator": ['Admin', 'DigitalTwinOperator', 'Operator', 'Manager'],
  "EBR.Manager": ['Admin', 'EBRManager', 'QualityManager'],
  "EBR.Manager.Or.Quality.Manager": ['Admin', 'EBRManager', 'QualityManager'],
  "Equipment.Manager": ['Admin', 'EquipmentManager', 'MaintenanceManager', 'Manager'],
  "Equipment.Operator": ['Admin', 'EquipmentOperator', 'MaintenanceTechnician', 'Operator'],
  "Finance.Accountant": ['Admin', 'FinanceAccountant', 'Accountant', 'Manager'],
  "Finance.Cfo": ['Admin', 'CFO', 'FinanceController', 'Manager'],
  "Finance.Controller": ['Admin', 'FinanceController', 'Manager'],
  "HR.Clerk": ['Admin', 'HRManager', 'HRClerk', 'Manager'],
  "HR.Manager": ['Admin', 'HRManager', 'Manager'],
  "HR.Payroll.Approver.Cfo": ['Admin', 'FinanceController', 'CFO'],
  "HR.Payroll.Approver.Director": ['Admin', 'HRDirector', 'FinanceController', 'CFO'],
  "Historian.Admin": ['Admin', 'HistorianAdmin', 'Manager'],
  "Historian.Reader": ['Admin', 'HistorianReader', 'Operator', 'Manager', 'Auditor'],
  "Historian.Writer": ['Admin', 'HistorianWriter', 'HistorianAdmin', 'Operator', 'Manager'],
  "Integration.Engineer": ['Admin', 'IntegrationEngineer', 'Manager'],
  "Integration.Operator": ['Admin', 'IntegrationOperator', 'Operator'],
  "Inventory.Manager": ['Admin', 'InventoryManager', 'Manager'],
  "Inventory.Operator": ['Admin', 'InventoryOperator', 'InventoryManager', 'Operator'],
  "Lims.Analyst": ['Admin', 'LimsAnalyst', 'LimsReviewer', 'LimsManager', 'QualityAuthor', 'Operator'],
  "Lims.Manager": ['Admin', 'LimsManager', 'QualityManager', 'Manager'],
  "Lims.Reviewer": ['Admin', 'LimsReviewer', 'LimsManager', 'QualityManager', 'Manager'],
  "Maintenance.Manager": ['Admin', 'MaintenanceManager', 'Manager'],
  "Maintenance.Supervisor": ['Admin', 'MaintenanceManager', 'MaintenanceSupervisor', 'Manager'],
  "Maintenance.Technician": ['Admin', 'MaintenanceManager', 'MaintenanceSupervisor', 'MaintenanceTechnician', 'Operator', 'Manager'],
  "Marketplace.Consumer": ['Admin', 'MarketplaceConsumer', 'Operator', 'Manager'],
  "Marketplace.Publisher": ['Admin', 'MarketplacePublisher', 'Manager'],
  "Materials.Manager": ['Admin', 'MaterialsManager', 'Manager'],
  "Materials.Operator": ['Admin', 'MaterialsOperator', 'MaterialsManager', 'Operator'],
  "MobileWms.Operator": ['Admin', 'MobileWmsOperator', 'InventoryOperator', 'Operator'],
  "MultiSite.IntercompanyFinanceApprover": ['Admin', 'MultiSiteIntercompanyFinanceApprover', 'FinanceController', 'Manager'],
  "MultiSite.Operator": ['Admin', 'MultiSiteOperator', 'Operator', 'Manager'],
  "MultiSite.RecipePropagationApprover": ['Admin', 'MultiSiteRecipePropagationApprover', 'MultiSiteManager', 'QualityManager', 'Manager'],
  "MultiSite.RegionGovernanceApprover": ['Admin', 'MultiSiteRegionGovernanceApprover', 'MultiSiteManager', 'Manager'],
  "OpcUa.Engineer": ['Admin', 'OpcUaEngineer', 'ControlsEngineer', 'Manager'],
  "OpcUa.Operator": ['Admin', 'OpcUaOperator', 'OpcUaEngineer', 'ControlsEngineer', 'Operator', 'Manager'],
  "PLM.Engineer": ['Admin', 'PLMEngineer', 'Engineer', 'Operator', 'Manager'],
  "PLM.Manager": ['Admin', 'PLMManager', 'Manager'],
  "Planning.Scheduler": ['Admin', 'PlanningScheduler', 'Planner', 'Manager'],
  "Predictive.Analyst": ['Admin', 'PredictiveAnalyst', 'Analyst', 'Manager'],
  "Predictive.Approver": ['Admin', 'PredictiveApprover', 'Manager'],
  "Predictive.Governor": ['Admin', 'PredictiveGovernor', 'Manager'],
  "Procurement.Approver": ['Admin', 'ProcurementApprover', 'Manager'],
  "Procurement.Buyer": ['Admin', 'ProcurementBuyer', 'Buyer', 'Operator'],
  "Procurement.SanctionsAdjudicator": ['Admin', 'SanctionsAdjudicator', 'ComplianceOfficer'],
  "Production.Operator": ['Admin', 'Operator', 'ProductionOperator', 'ProductionSupervisor'],
  "Production.Supervisor": ['Admin', 'ProductionSupervisor', 'Manager'],
  "Quality.Author": ['Admin', 'QualityAuthor', 'QualityManager'],
  "Quality.Manager": ['Admin', 'QualityManager'],
  "Sales.Manager": ['Admin', 'SalesManager', 'Manager'],
  "Sales.Rep": ['Admin', 'SalesRep', 'Manager'],
  "Scada.Engineer": ['Admin', 'ScadaEngineer', 'ControlsEngineer', 'Manager'],
  "Scada.Operator": ['Admin', 'ScadaOperator', 'Operator'],
  "Scim.Provisioner": ['Admin', 'ScimProvisioner'],
  "Simulator.Intent": [],
  "Sustainability.Analyst": ['Admin', 'SustainabilityAnalyst', 'Analyst'],
  "Sustainability.Assurer": ['Admin', 'SustainabilityAssurer', 'Auditor', 'Manager'],
  "Sustainability.Controller": ['Admin', 'SustainabilityController', 'Manager'],
  "Vision.Approver": ['Admin', 'VisionApprover', 'QualityManager', 'Manager'],
  "Vision.Engineer": ['Admin', 'VisionEngineer', 'Manager'],
  "Vision.Operator": ['Admin', 'VisionOperator', 'VisionEngineer', 'Operator'],
  "Widgets.Admin": ['Admin', 'WidgetsAdmin'],
  "Widgets.Editor": ['Admin', 'WidgetsEditor', 'Manager'],
  "Workflow.Author": ['Admin', 'WorkflowAuthor'],
  "Workflow.Designer": ['Admin', 'WorkflowAuthor', 'WorkflowDesigner'],
  "Workflow.Reader": ['Admin', 'WorkflowAuthor', 'WorkflowReader', 'Operator', 'Manager'],
  "Workforce.Admin": ['Admin', 'WorkforceAdmin', 'Manager'],
  "admin.breakglass.approve": ['Admin', 'BreakGlassApprover'],
  "admin.keys": ['Admin', 'KeyCustodian'],
  "admin.oauth2.register": ['Admin', 'OAuth2Registrar'],
  "supplier-portal": ['Admin', 'Supplier', 'SupplierPortalUser'],
} as const satisfies Record<string, readonly string[]>;

/** A named policy the gateway actually registers. */
export type ServerPolicyName = keyof typeof SERVER_POLICY_ROLES;

/** Every registered policy name, for exhaustiveness checks and tooling. */
export const SERVER_POLICY_NAMES = Object.keys(SERVER_POLICY_ROLES) as ServerPolicyName[];
